import "../../../../assets/CreditAnalyse/css/loaderOTP.scss";
import { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";

import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { getPageName } from "../../../../Constants/PageNames";
import { queryString } from "../../../../Utility/QueryString";
import { useSkippedLeads } from "../../../../Hooks/useSkippedLeads";
import { useGetCreditAnalysisDataV2 } from "../../../../Hooks/useGetCreditAnalysisDataV2";

import Logowhite from "../../../../assets/CreditAnalyse/img/logo-white.e7860257.png";
import Secureicon from "../../../../assets/CreditAnalyse/img/security-safe-svgrepo-com.svg";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import ReferenceContext from "../../../../Contexts/ReferenceContext";
import GetVisitorsParams from "../../../../Utility/GetVisitorsParams";

const CreditCheck_Send_Otp_FLP_OD = ({
  userData,
  uuid,
  allFollowupData,
  removeFromPending,
  addPending
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const history = useHistory();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const { getCreditAnalysisDataV2 } = useGetCreditAnalysisDataV2();
  const { setReferenceID } = useContext(ReferenceContext);
  const { savePageLoad, calledOnce } = usePageLoad();
  const splitName = localStorage.getItem("split_name");
  const nextPage = urlParams.get("nextPage") || "";
  const { skippedLeads } = useSkippedLeads();
  const flp_source = allFollowupData.atp_sub6;

  useEffect(() => {
    const is_confirmed = localStorage.getItem("is_confirmed") || false;
    (async () => {
      if (!Boolean(is_confirmed)) {
        const res = await getCreditAnalysisDataV2(uuid, userData, "send_otp");
        setTimeout(() => {
          if (!!res.data.error) {
            let nextSlide = localStorage.getItem("EditPage");
            if (nextSlide == "visited") {
              removeFromPending("send_otp_flp");
              removeFromPending("submit_otp_flp");
              removeFromPending("otp_confirmation_page");
            } else {
              addPending("editdetails_flp");
            }
            return false;
          }
          if (
            res.data.status === "Success" &&
            res?.data?.response?.vendor_response?.Info?.Data?.reference
          ) {
            setReferenceID(
              res?.data?.response?.vendor_response?.Info?.Data?.reference
            );
          }

          if (
            res.data.status === "Success" &&
            (res?.data?.response?.vendor_response?.Info?.Message ===
              "Phone number assessed not to be high-risk" ||
              res?.data?.response?.is_dupe === "yes")
          ) {
            let type = "";
            if (res?.data?.response?.is_dupe === "yes") {
              type = "cc_duplicate";
            } else {
              type = "phone_assessment";
            }

            const skippedLeadsResponse = skippedLeads(type, uuid, splitName);

            removeFromPending("send_otp_flp");
            removeFromPending("submit_otp_flp");
          } else {
            removeFromPending("send_otp_flp");
          }
        }, 3000);
      }
    })();
  }, []);

  useEffect(() => {
    const is_confirmed = localStorage.getItem("is_confirmed") || false;
    if (!!uuid && !calledOnce) {
      if (!Boolean(is_confirmed)) {
        const data = {
          uuid,
          page_name: getPageName("credit"),
          status: "visited",
          source: flp_source,
        };
        (async () => {
          await savePageLoad(
            uuid,
            data,
            "visited_status",
            splitName,
            queryString,
            visitorParameters.data
          );
        })();
      }
    }
  }, [uuid, calledOnce]);

  return (
    <>
      <GetVisitorsParams />
      <div className="loaderOTP">
        <div className="bg_preldr">
          <div className="container" style={{ marginTop: "-150px" }}>
            <div>
              <div className="brand">
                <div className="logo pt-3 text-center">
                  <a href="index.html">
                    <img src={Logowhite} height={60} alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="preloader">
            <div className="box">
              <div className="logo">
                <img height={40} src={Secureicon} alt="" />
              </div>
            </div>
            <div className="box" />
            <div className="box" />
            <div className="box" />
            <div className="box" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditCheck_Send_Otp_FLP_OD;
